export default [
  {
    value: 'STAND',
    text: 'Стойка'
  },
  {
    value: 'STOP',
    text: 'Остановка'
  }
]
